import { render, staticRenderFns } from "./LsServiceDetails.vue?vue&type=template&id=a39473b6&scoped=true&"
import script from "./LsServiceDetails.vue?vue&type=script&lang=js&"
export * from "./LsServiceDetails.vue?vue&type=script&lang=js&"
import style0 from "./LsServiceDetails.vue?vue&type=style&index=0&id=a39473b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a39473b6",
  null
  
)

export default component.exports